import { ERROR_HELP_STATE } from "../core/constants";
import { getComponentData, setComponentData } from "../core/views";
import { getErrorHelpData } from "./requests";

export async function loadErrorHelp(path : string) {
  const data = await getErrorHelpData(path);

  setComponentData(ERROR_HELP_STATE, data);
}

export const getHelpForError = (message : string) => {
  const errorHelpData = getComponentData(ERROR_HELP_STATE);
  let errorHelpEntry = errorHelpData?.errorHelp?.find((entry) => message?.indexOf(entry.keyword) > -1);
  console.log('get error help', errorHelpEntry)
  let currentError = {}
  if (errorHelpEntry) {
    const item = message.replace(errorHelpEntry.keyword, "")
    currentError = {
      translated: errorHelpEntry.translated.replace("$1", item),
      shortHelp: errorHelpEntry.shortHelp.replace("$1", item),
      item,
      lineHelpEnabled: errorHelpEntry.lineHelpEnabled !== undefined ? errorHelpEntry.lineHelpEnabled : true,
      message
    }
    setComponentData(ERROR_HELP_STATE, {
      ...errorHelpData,
      currentError
    })
    return currentError;
  }

  currentError = {
    name: "ERROR",
    keyword: "Error",
    translated: "Allgemeiner Fehler",
    shortHelp : "Suche nach Tippfehlern und durchsuche auch deine anderen Codezeilen! Vielleicht hast du dich vertippt!?",
    lineHelpEnabled: false,
    message
  }

  setComponentData(ERROR_HELP_STATE, {
    ...errorHelpData,
    currentError
  })
  return currentError;
}

const getCharCount = (str : string, char: string) => {
  var replace = char;
  var re = new RegExp(replace,"g");
  const result = str.match(re);
  if (result !== null) {
    return result.length;
  }
  return 0;
}

export const checkCodePlausibilitiy = (code : string[]) => {
  let openCurlyBraces = 0;
  let closedCurlyBraces = 0;
  let openBraces = 0;
  let closedBraces = 0;
  let openSquareBraces = 0;
  let closedSquareBraces = 0;
  let doubleQuotes = 0;
  let singleQuotes = 0;

  code.forEach((line) => {
    if (getCharCount(line, '{') > 0) openCurlyBraces += getCharCount(line, '{');
    if (getCharCount(line, '}') > 0) closedCurlyBraces += getCharCount(line, '}');
    if (getCharCount(line, '\\(') > 0) openBraces += getCharCount(line, '\\(');
    if (getCharCount(line, '\\)') > 0) closedBraces += getCharCount(line, '\\)');
    if (getCharCount(line, '\\[') > 0) openSquareBraces += getCharCount(line, '\\[');
    if (getCharCount(line, '\\]') > 0) closedSquareBraces += getCharCount(line, '\\]');
    if (getCharCount(line, '"') > 0) doubleQuotes += getCharCount(line, '"');
    if (getCharCount(line, "'") > 0) singleQuotes += getCharCount(line, "'");
  })

  /*
  console.log('open and closed CurlyBraces', openCurlyBraces, closedCurlyBraces)
  console.log('open and closed Braces', openBraces, closedBraces)
  console.log('open and closed SquareBraces', openSquareBraces, closedSquareBraces)
  console.log('doubleQuotes', doubleQuotes)
  console.log('singleQuotes', singleQuotes)
  */

  if (openCurlyBraces !== closedCurlyBraces) {
    console.log("curly braces not plausible!");
    if (openCurlyBraces > closedCurlyBraces) {
      return getHelpForError('missing }');
    } else {
      return getHelpForError('missing {');
    }
  }
  if (openBraces !== closedBraces) {
    console.log("round braces not plausible!");
    if (openBraces > closedBraces) {
      return getHelpForError('missing )');
    } else {
      return getHelpForError('missing (');
    }
  }
  if (openSquareBraces !== closedSquareBraces) {
    console.log("square braces not plausible!");
    if (openSquareBraces > closedSquareBraces) {
      return getHelpForError('missing ]');
    } else {
      return getHelpForError('missing [');
    }
  }
  if ((doubleQuotes % 2) > 0) {
    console.log("double quotes not plausible!");
    return getHelpForError('missing "');
  }
  if ((singleQuotes % 2) > 0) {
    console.log("single quotes not plausible!");
    return getHelpForError("missing '");
  }
  return undefined;
}
